const Helpers = {
  buildUrl (url, parameters) {
    let currentParameters = {};

    if (url === undefined || !Object.keys(parameters).length) {
      return url;
    }

    // Checks and splits the url if it already has a first parameter
    let splitUrl = url.split('?');

    if (splitUrl.length > 1) {
      // Checks and splits the parameter part of the url if there are multiple parameters
      let splitParameters = splitUrl[1].split('&');

      // Splits the parameters and saves them as key and value
      for (let splitParameter of splitParameters) {
        let keyValue = splitParameter.split('=');

        currentParameters[keyValue[0]] = keyValue[1];
      }
    }

    // Combines the pre-set parameters of the url with the method parameters
    parameters = Object.assign(currentParameters, parameters);

    // Joins all the parameters into one string
    let urlQueries = Object.entries(parameters)
      .map(keyValue => keyValue.join('='))
      .join('&');

    return splitUrl[0] + '?' + urlQueries;
  },
};

export default Helpers;
